<template>
    <b-modal v-model="showModal" @hidden="fecharModal" ref="modalAutorizacaoFornecedor" size="xl" hide-footer
        :title="title">
        <b-card>
            <b-row>
                <b-col>
                    <LgFormInput :disabled="isViewMode" id="numAutorizacao" v-model="numAutorizacao"
                        label="Nº Autorização:*">
                    </LgFormInput>

                </b-col>
                <b-col>
                    <LgFormInput :disabled="isViewMode" id="numProcesso" v-model="numProcesso" label="Nº Processo:"
                        readonly></LgFormInput>


                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <LgFormDate :disabled="isViewMode" id="dataAutorizacao" description='' v-model="dataAutorizacao"
                        label="Data da Autorização:*">
                    </LgFormDate>

                </b-col>
                <b-col>
                    <LgFormDate :disabled="isViewMode" id="dataprevisaoentrega" description=''
                        v-model="dataprevisaoentrega" label="Data de Previsão de Entrega:*">
                    </LgFormDate>

                </b-col>
            </b-row>
            <LgFormTextarea :disabled="isViewMode" id="descricao" v-model="descricao" description=''
                label="Descrição:*">
            </LgFormTextarea>
            <LgFormInput id="tipoAutorizacao" v-model="tipoAutorizacao" label="Tipo de Autorização:" disabled>
            </LgFormInput>
        </b-card>
        <b-card>
            <LgFinderPageBanco :disabled="isViewMode" class='col-12' v-model="banco" label="Banco:*" id="finderBanco"
                invalidFeedback="Banco deve ser informado!" description="" :prefix="updatedPrefix" />
            <LgFinderPageEmpenho :disabled="isViewMode" class='col-12' id="finderPageEmpenho" v-model="empenho"
                invalidFeedback="Empenho deve ser informada!" description="" :prefix="updatedPrefix"
                label="Número Empenho:*">
            </LgFinderPageEmpenho>
            <LgFormTextarea :disabled="isViewMode" id="enderecoEntrega" description='' v-model="enderecoEntrega"
                label="Endereço de Entrega:*" required>
            </LgFormTextarea>
            <LgFormTextarea :disabled="isViewMode" id="observacao" v-model="observacao" description=''
                label="Observação:*" required>
            </LgFormTextarea>
        </b-card>
        <b-card>
            <LgFinderPageEmpresa :processo="processoId" :prefix="updatedPrefix" v-model="empresa" @input="selectEmpresa"
                :disabled="isViewMode" id="finderPageEmpresaConsultarProcessoCompraForm" label="Empresa:*" />


            <b-table :items="itens" :fields="itensFields" :busy="busy">
                <template #cell(quantidade)="data">
                    <b-form-input style="height: 20px;" :disabled="isViewMode" v-model="data.item.quantidade"
                        type="number" min="1" required></b-form-input>
                </template>
                <template #cell(valorUnitario)="data">
                    <b-form-input style="height: 20px;" :disabled="isViewMode" v-model="data.item.valorUnitario"
                        type="number" min="0" step="1" required></b-form-input>
                </template>
            </b-table>
        </b-card>
        <b-form @submit.prevent="submitForm">
            <div class="d-flex justify-content-center mt-3">
                <b-button id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px" pill size="sm"
                    :disabled="isViewMode">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check-circle" />
                    </div>
                </b-button>
                <b-button id="cancelarSalvar" class="ml-2" @click="fecharModal" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>
        </b-form>

    </b-modal>
</template>

<script>
import LgFinderPageBanco from "@/components/Finders/LgFinderPageBanco.vue"
import LgFinderPageEmpenho from "@/components/Finders/LgFinderPageEmpenho.vue"
import AutorizacaoFornecedorService from "@/core/api/AutorizacaoFornecedorService"
import ProcessoCompraService from "@/core/api/ProcessoCompraService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue"
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import ResourceService from "@/core/api/ResourceService";

export default {
    components: {
        LgFormDate,
        LgFormInput,
        LgFormTextarea,
        LgFinderPageBanco,
        LgFinderPageEmpenho,
        LgFinderPageEmpresa,
    },
    props: {
        autorizacaoFornecedorId: {
            type: Number,
            default: null
        },
        isViewMode: {
            type: Boolean,
            default: false,
        },
        processoId: {
            type: Number,
            required: true
        },
        prefix: {
            type: Array,
            required: true
        }
    },
    data() {
        return {

            busy: false,
            itens: [],
            itensFields: [
                { key: 'descricaoResumida', label: 'Nome' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'valorUnitario', label: 'Valor' },
                { key: 'actions', label: ' ' }
            ],

            empresa: {},
            showModal: true,
            numAutorizacao: "",
            numProcesso: "",
            dataAutorizacao: "",
            dataprevisaoentrega: "",
            descricao: "",
            tipoAutorizacao: "",
            banco: null,
            empenho: null,
            enderecoEntrega: "",
            observacao: "",
            fornecedor: "",
            motivo: "",
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    methods: {

        async selectEmpresa(empresa) {
            this.empresa = empresa;

            this.busy = true;
            var { data } = await new ResourceService('/api/processocompra').get(`${this.processoId}/${empresa.id}/itens-para-autorizacao-fornecimento`);
            this.itens = data;
            this.busy = false;


        },
        async submitForm() {
            if (!this.numProcesso) {
                this.$bvToast.toast('O campo Nº de Autorização é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }

            if (!this.dataAutorizacao) {
                this.$bvToast.toast('O campo Data da Autorização é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }

            if (!this.dataprevisaoentrega) {
                this.$bvToast.toast('O campo Data de Previsão de Entrega é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }

            if (!this.descricao) {
                this.$bvToast.toast('O campo de Descrição é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }


            if (!this.banco) {
                this.$bvToast.toast('O campo Banco é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (!this.enderecoEntrega) {
                this.$bvToast.toast('O campo Endereço de Entrega é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (!this.observacao) {
                this.$bvToast.toast('O campo Observação é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            if (!this.empenho) {
                this.$bvToast.toast('O campo Número Empenho é obrigatório.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }

            if (!this.empresa || !this.empresa.id) {
                this.$bvToast.toast('Selecione uma empresa', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }


            for (const item of this.itens) {
                if (!item.quantidade || item.quantidade <= 0) {
                    this.$notify({
                        message: 'Por favor, preencha o campo Quantidade para todos os itens.',
                        type: 'danger',
                        solid: true
                    })
                    return
                }
                if (item.quantidade > item.qtdMaxima) {
                    this.$notify({
                        message: `A quantidade do item ${item.descricaoResumida} não pode exceder ${item.qtdMaxima}.`,
                        type: 'danger',
                        solid: true
                    })
                    return
                }
                if (!item.valorUnitario || item.valorUnitario < 0) {
                    this.$notify({
                        message: 'Por favor, preencha o campo Valor para todos os itens.',
                        type: 'danger',
                        solid: true
                    })
                    return
                }
            }


            const autorizacaoFornecedor = {
                empresa: { id: this.empresa.id },
                descricao: this.descricao,
                dataprevisaoentrega: this.dataprevisaoentrega,
                numeroProcesso: this.numAutorizacao,
                dataAutorizacao: this.dataAutorizacao,
                banco: this.banco,
                enderecoEntrega: this.enderecoEntrega,
                observacao: this.observacao,
                empenho: this.empenho,
                processoCompra: { id: this.processoId },
                itens: this.itens
            }
            try {
                await AutorizacaoFornecedorService.create(autorizacaoFornecedor)
                this.fecharModal()
            } catch (error) {
                this.$bvToast.toast(error.response.data, {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            }
        },
        async fetchData() {

            const response = await ProcessoCompraService.findById(this.processoId)
            this.numProcesso = response.data.numeroProcesso;
            this.tipoAutorizacao = response.data.classificacao.descricao;

            if (this.isViewMode) {
                var { data } = await AutorizacaoFornecedorService.findById(this.autorizacaoFornecedorId);

                this.descricao = data.descricao;
                this.numAutorizacao = data.numeroProcesso;
                this.dataAutorizacao = data.dataAutorizacao;
                this.dataprevisaoentrega = data.dataprevisaoentrega;
                this.banco = data.banco;
                this.numProcesso = data.numeroProcesso
                this.empenho = data.empenho;
                this.enderecoEntrega = data.enderecoEntrega;
                this.observacao = data.observacao;
                this.empresa = data.empresa;
                this.itens = data.itens;


            }
            else {

                this.descricao = ""
                this.numAutorizacao = ""
                this.dataAutorizacao = "";
                this.dataprevisaoentrega = "";

            }
        },
        fecharModal() {
            this.$emit('close')
        }
    },
    async beforeMount() {
        this.fetchData();
    }
}
</script>
